import React, { useEffect, useRef, useState } from 'react'
import api from '../../../api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';


const Assessment_5 = () => {
      const userID = sessionStorage.getItem("UserID");
      const currentDate1 = new Date();
      const formattedCurrentDate = `${currentDate1.getDate().toString().padStart(2, '0')}-${(currentDate1.getMonth() + 1).toString().padStart(2, '0')}-${currentDate1.getFullYear()} ${currentDate1.getHours().toString().padStart(2, '0')}:${currentDate1.getMinutes().toString().padStart(2, '0')}:${currentDate1.getSeconds().toString().padStart(2, '0')}`;
      const dt = useRef(null);
      const toast = useRef(null);

      const [loading, setLoading] = useState(false);

      const [data, setData] = useState([]);
      const getDemographicRawData = async () => {
        try {
          setLoading(true);

          const requestData = {
            logged_in_userid: userID,
            table_name:"trn_tbl_phq9_screening",
            synceddatetime: formattedCurrentDate,
            FormCode: "202",
            ApiKey: "kavin",
            AppTypeNo: "3",
            AppVersion: "1.0.0",
            data_source: "W"
          };
    
        const result = await api.get_Raw_Data(requestData);
        const responseData = result.trn_tbl_phq9_screening;
        const slNo = responseData.map((item, index) => ({
                   ...item, slno: index + 1
               }));
               setData(slNo);
        } catch (error) {
          console.error("Error fetching state:", error);
          toast.current.show({
            severity: "info",
            summary: "No Data Found",
            detail: "There is no data for this table"
          });
        } finally {
          setLoading(false);
        }
      };
    
      useEffect(() => {
        getDemographicRawData();
      }, []);

      const cleanValue = (value) => {
        if (value === "-999" || value === -999) return "";

        if (typeof value === "string" && value.includes("$")) {
          return value.split("$").join(",");
        }

        return value;
      };



    const exportData = data.map(item => ({
        "SlNo": item.slno,
        "Sate" : cleanValue(item.fld_state_name),
        "District" : cleanValue(item.fld_district_name),
        "Site" : cleanValue(item.fld_site_name),
        "Taluk" : cleanValue(item.fld_taluk_name),
        "Village" : cleanValue(item.fld_village_name),
        "PHC" : cleanValue(item.fld_phc_name),
        // "PHC Type" : cleanValue(item.fld_phc_type_name),
        // "PRS name" : cleanValue(item.fld_prs_name),
        // "Participant registration date" : cleanValue(item.fld_participant_registration_date),
        "Participant Name" : cleanValue(item.fld_participant_name),
        "Participant ID" : cleanValue(item.fld_participant_id),
        "FU visit number": cleanValue(item.fld_fu_visit_number),
        "FU visit date": cleanValue(item.fld_fu_visit_date),
        "PHQ9 done date":cleanValue(item.fld_phq9_done_date),
        "Little interest or pleasure in doing things":cleanValue(item.fld_little_interest_pleasure_doing_thing_name),
        "Feeling down, depressed, or hopeless":cleanValue(item.fld_feeling_down_depressed_hopeless_name),
        "Trouble falling or staying asleep, or sleeping too much":cleanValue(item.fld_trouble_falling_sleep_much_name),
        "Feeling tired or having little energy":cleanValue(item.fld_feeling_tried_having_energy_name),
        "Poor appetite or overeating":cleanValue(item.fld_poor_appetite_overeating_name),
        "Feeling bad about yourself or that you are a failure or have let yourself or your family down":cleanValue(item.fld_feel_bad_abt_yrslf_name),
        "Trouble concentrating on things, such as reading the newspaper or watching television":cleanValue(item.fld_trouble_concentrating_things_name),
        "Moving or speaking so slowly that other people could have noticed. Or the opposite being so fidgety or restless that you have been moving around a lot more than usual":cleanValue(item.fld_moving_speaking_slowly_or_fidgety_name),
        "Thoughts that you would be better off dead, or of hurting yourself":cleanValue(item.fld_offdead_hurting_youreself_name),
        "If you checked off any problems, how difficult Not difficult at all have these problems made it for you to do your work, take care of things at home, or get along with other people?":cleanValue(item.fld_other_problem_checked_name),
        "Total score":cleanValue(item.fld_total_score),
        "Loggedin User ID": cleanValue(item.fld_loggedin_user_id),
        "System Inserted Date": item.fld_system_inserted_datetime
          ? new Date(item.fld_system_inserted_datetime).toISOString().split("T")[0]
          : "", // fallback in case value is missing
    }));

      const handleDownloadCSV = () => {
          if (!data || data.length === 0) {
            console.warn("No data available to export");
            return;
          }

          // Convert JSON to worksheet
          const worksheet = XLSX.utils.json_to_sheet(exportData);

          // Create a new workbook and append the worksheet
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, `Assessment_using_PHQ-9_Data`);

          // Generate buffer
          const excelBuffer = XLSX.write(workbook, {
            bookType: "csv",
            type: "array"
          });

          // Create Blob and trigger download
          const dataBlob = new Blob([excelBuffer], { type: "text/csv;charset=utf-8;" });
          saveAs(dataBlob, "Assessment_using_PHQ-9_Data.csv");
        };


  return (
    <div>
        <Toast ref={toast} position="top-right" />

        {loading && (
            <div className="backdrop">
                <ProgressSpinner style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
            </div>
        )}
        <span className='flex justify-content-end mt-2 mb-4'>
            <Button className="downloadbutton"
                label='Download CSV'
                icon="pi pi-download"
                onClick={handleDownloadCSV}
            />
        </span>
            <DataTable
              value={data}
              scrollHeight="350px"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              ref={dt}
              scrollable
            >
              <Column field="slno" header="Sl.No" />
              <Column field="fld_phc_name" header="PHC Name" />
              <Column field="fld_loggedin_user_id" header="User ID" />
              <Column field="fld_participant_name" header="Participent Name"></Column>
              <Column field="fld_participant_id" header="Participent ID"></Column>
              <Column field="fld_phq9_done_date" header="PHQ9 done date"></Column>
              <Column field="fld_little_interest_pleasure_doing_thing_name" header="Q 1"></Column>
              <Column field="fld_feeling_down_depressed_hopeless_name" header="Q 2"></Column>
              <Column field="fld_trouble_falling_sleep_much_name" header="Q 3"></Column>
              <Column field="fld_feeling_tried_having_energy_name" header="Q 4"></Column>
              <Column field="fld_poor_appetite_overeating_name" header="Q 5"></Column>
              <Column field="fld_feel_bad_abt_yrslf_name" header="Q 6"></Column>
              <Column field="fld_trouble_concentrating_things_name" header="Q 7"></Column>
              <Column field="fld_moving_speaking_slowly_or_fidgety_name" header="Q 8"></Column>
              <Column field="fld_offdead_hurting_youreself_name" header="Q 9"></Column>
              <Column field="fld_other_problem_checked_name" header="Q 10"></Column>
              <Column field="fld_total_score" header="Total score"></Column>
            </DataTable>
    </div>
  )
}

export default Assessment_5